import { render } from "./WebPage.vue?vue&type=template&id=76aa548e&scoped=true"
import script from "./WebPage.vue?vue&type=script&lang=js"
export * from "./WebPage.vue?vue&type=script&lang=js"

import "./WebPage.vue?vue&type=style&index=0&id=76aa548e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76aa548e"]])

export default __exports__